var _style, _path, _g, _path2, _path3, _path4, _polygon, _path5, _path6, _rect, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#C39382;}\n\t.st2{fill:#B58478;}\n\t.st3{fill:#5D4F4A;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.3,182.9c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6S29,63.99,29,106.3 C29,148.6,63.61,182.9,106.3,182.9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.08,110.08c-2.61-5.15-7.25-7.8-12.77-8.9c-5.25-1.04-10.67-0.56-15.89-1.75 c-0.89-0.2-1.77-0.45-2.62-0.77c-0.37-0.14-0.75-0.29-1.11-0.46c-1.14-0.53-2.21-1.21-3.14-2.06c-2.1-1.92-3.22-4.58-3.73-7.33 c-0.6-3.28-0.43-6.64-0.15-9.95c0.32-3.82,0.72-7.63,1.08-11.45c0.09-0.87-0.42-1.42-1.06-1.63c-0.09-0.06-0.2-0.12-0.31-0.17 c-3.88-1.48-8.24-0.9-11.58,1.57c-1.7,1.26-2.82,2.88-3.65,4.67c-9.78,1.19-19.61,1.86-29.46,1.99c-0.49,0.01-0.88,0.19-1.18,0.47 c-0.42,0.28-0.73,0.7-0.72,1.2c0.23,7.39,0.69,14.78,1.39,22.14c-2.25,3.74-3.11,8.06-3.26,12.38c-0.19,5.29,0.45,10.6,1.79,15.71 c0.02,0.05,0.04,0.09,0.06,0.13c-0.1,0.27-0.13,0.56-0.12,0.87c0.05,0.99,0.1,1.97,0.15,2.97c0.03,0.8-0.08,1.88,0.31,2.63 c0.8,1.51,3.11,1.14,4.52,1.2c4,0.19,8.02,0.36,12.02,0.54l6.02,0.27c1.85,0.09,3.79,0.34,5.64,0.19c2.48-0.2,3.53-1.87,3.7-3.87 c18.25,3.7,37.2,3.61,55.43-0.25c0.87,0.18,1.86-0.26,1.95-1.41C157.82,122.7,156.97,115.81,154.08,110.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.66,109.46c-6.02-7.94-15.81-11.66-25.53-11.71c-2.21,3.72-3.08,8.01-3.22,12.32 c-0.18,5.29,0.45,10.59,1.8,15.7c0.01,0.05,0.03,0.09,0.05,0.14c-0.09,0.27-0.13,0.56-0.12,0.86c0.05,0.99,0.1,1.98,0.15,2.97 c0.04,0.8-0.08,1.88,0.31,2.63c0.8,1.51,3.11,1.14,4.52,1.21c4.01,0.18,8.02,0.36,12.02,0.53l6.01,0.27 c1.86,0.08,3.79,0.33,5.64,0.19c2.48-0.2,3.52-1.87,3.7-3.87c0.79,0.16,1.58,0.3,2.37,0.45 C101.52,123.45,99.28,115.55,94.66,109.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.32,129.23c-16.46,0.18-32.9-0.99-49.35-1.48c-0.1,0-0.18-0.03-0.27-0.04c0.03,0.68,0.07,1.35,0.1,2.03 c0.04,0.8-0.08,1.88,0.31,2.63c0.8,1.51,3.11,1.14,4.52,1.21c4.01,0.18,8.02,0.36,12.02,0.53l6.01,0.27 c1.86,0.08,3.79,0.33,5.64,0.19c2.48-0.2,3.52-1.87,3.7-3.87c18.25,3.7,37.2,3.61,55.42-0.25c0.88,0.17,1.87-0.27,1.95-1.41 c0.09-1.27,0.11-2.56,0.09-3.85C144.15,127.44,130.94,129.08,117.32,129.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.8,98.66c-1.67,1.59-3.72,2.75-6.01,3.03c-6.24,0.75-10.79-5.22-13.53-10.01 c-3.3-5.77-4.96-12.41-4.81-19.05c0.02-0.71,1.11-0.6,1.09,0.09c-0.07,3.46,0.36,6.91,1.28,10.26c0.82,2.95,2.02,5.78,3.55,8.43 c1.44,2.49,3.19,4.96,5.42,6.8c2.09,1.73,4.69,2.83,7.43,2.29c1.68-0.34,3.18-1.19,4.47-2.3C122.05,98.37,122.42,98.52,122.8,98.66 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.16,76.65c-4.81,1.02-9.72,1.38-14.63,1.04c-1.41-0.1-1.61,2.09-0.19,2.19c5.09,0.35,10.22,0,15.22-1.07 C115.94,78.52,115.55,76.35,114.16,76.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.23,85.88c-3.72,1.2-7.48,2.29-11.27,3.27c-0.58,0.15-1,0.67-0.88,1.28c0.1,0.55,0.7,1.03,1.28,0.88 c3.79-0.98,7.55-2.07,11.27-3.27c0.56-0.18,1-0.64,0.88-1.28C115.41,86.24,114.8,85.7,114.23,85.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M118.1,92.84c-0.53-0.37-1.14-0.17-1.53,0.28c-1.79,2.05-4.03,3.78-6.44,5.04c-0.53,0.27-0.78,0.92-0.51,1.47 c0.25,0.52,0.94,0.79,1.47,0.51c2.78-1.45,5.23-3.41,7.29-5.77C118.77,93.92,118.55,93.15,118.1,92.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.79,97.22c-0.58-0.18-1.19,0.08-1.41,0.66c-0.31,0.8-0.65,1.59-1.02,2.37c-0.09,0.19-0.18,0.38-0.28,0.56 c-0.04,0.07-0.08,0.14-0.11,0.22c0,0.01,0,0.01-0.01,0.02c0,0,0,0.01-0.01,0.01c0,0.01-0.01,0.02-0.02,0.03c0,0,0,0,0-0.01 c-0.02,0.03-0.04,0.07-0.05,0.1c-0.21,0.39-0.42,0.78-0.65,1.16c-0.29,0.5-0.25,1.2,0.28,1.53c0.47,0.3,1.22,0.25,1.53-0.28 c0.92-1.59,1.73-3.25,2.39-4.97C123.66,98.09,123.35,97.4,122.79,97.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M119.98,101.03c0.04-0.07-0.01,0-0.03,0.06c0-0.01,0.01-0.02,0.01-0.03 C119.97,101.05,119.97,101.04,119.98,101.03z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.35,92.73c0-0.04-0.01-0.08-0.01-0.11C115.35,92.66,115.35,92.7,115.35,92.73L115.35,92.73z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.12,91.16L115.12,91.16c0.02,0.08,0.03,0.17,0.04,0.25C115.15,91.33,115.14,91.25,115.12,91.16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.55,89.14c-0.02-0.07-0.05-0.13-0.07-0.2C114.5,89.01,114.53,89.07,114.55,89.14L114.55,89.14z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "113.62,101.26 113.62,101.26 113.62,101.27 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.33,95.81c0,0.02,0,0.04-0.01,0.07C115.32,95.85,115.32,95.83,115.33,95.81z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.23,103.39L112.23,103.39c-0.26,0.33-0.53,0.66-0.83,0.98C111.69,104.05,111.96,103.72,112.23,103.39z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 112.93,
    y: 102.42,
    transform: "matrix(0.9996 -0.029 0.029 0.9996 -2.9222 3.3176)",
    className: "st4",
    width: 0,
    height: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.08,97.34c-0.01,0.02-0.01,0.04-0.02,0.07C115.07,97.38,115.07,97.36,115.08,97.34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115.42,94.27c0,0.01,0,0.02,0,0.03C115.42,94.29,115.42,94.28,115.42,94.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiking);
export default __webpack_public_path__ + "static/media/Hiking.60b83cdc0bdec9665ee685c15428a0d3.svg";
export { ForwardRef as ReactComponent };